import React from 'react';

interface LogoProps {
  className?: string;
}

export function Logo({ className = "h-8 w-auto" }: LogoProps) {
  return (
    <img
      src="https://atividade.neurosaber.com.br/wp-content/uploads/2025/02/neuropainel-fundoescuro.svg"
      alt="Neurosaber"
      className={className}
    />
  );
}